import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step2Contact() {
  const {
    data,
    updateData
  } = useIntake();
  const addDecisionMaker = () => {
    const newPerson = {
      id: Date.now().toString(),
      name: '',
      role: '',
      email: '',
      phone: '',
      involvement: '',
      decisionRole: ''
    };
    updateData({
      owners: [...data.owners, newPerson]
    });
  };
  const removeDecisionMaker = (id: string) => {
    updateData({
      owners: data.owners.filter(o => o.id !== id)
    });
  };
  const updateDecisionMaker = (id: string, field: string, value: string) => {
    updateData({
      owners: data.owners.map(o => o.id === id ? {
        ...o,
        [field]: value
      } : o)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-342" data-mp="1jkd4ekjas2c5">
      <MascotPanel message="Laten we beginnen met uw contactgegevens. Zo weet ik precies met wie ik het genoegen heb en hoe we u het beste kunnen bereiken tijdens het project." data-id="element-343" data-mp="1ajf7em7a0v32" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-344" data-mp="2291m6xmhhrjp">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-345" data-mp="1ohve4d552ll7">
          Hoofdcontactpersoon
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-346" data-mp="1tgzoh73supd4">
          <Input label="Volledige naam" placeholder="Bijv. Jan Jansen" value={data.contactName} onChange={e => updateData({
          contactName: e.target.value
        })} data-id="element-347" data-mp="2h72b37oy334c" />
          <Input label="Functie / Rol" placeholder="Bijv. Eigenaar of Marketing Manager" value={data.contactRole} onChange={e => updateData({
          contactRole: e.target.value
        })} data-id="element-348" data-mp="2vryc4hiqm2dt" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-349" data-mp="2cvgczf1k707j">
          <Input label="E-mailadres" type="email" placeholder="jan@bedrijf.nl" value={data.contactEmail} onChange={e => updateData({
          contactEmail: e.target.value
        })} data-id="element-350" data-mp="2cwrgrev087yn" />
          <Input label="Telefoonnummer" type="tel" placeholder="06 12345678" value={data.contactPhone} onChange={e => updateData({
          contactPhone: e.target.value
        })} data-id="element-351" data-mp="1y8dep65ewnj5" />
        </div>

        <div className="space-y-6" data-id="element-352" data-mp="4pwan6lw2v89">
          <div data-id="element-353" data-mp="8ovmzc9y9u9q">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-354" data-mp="8odk3wss8hsu">
              Bent u de eigenaar van het bedrijf?
            </label>
            <RadioGroup columns={2} value={data.isOwner} onChange={val => updateData({
            isOwner: val
          })} options={[{
            value: 'yes',
            label: 'Ja, ik ben eigenaar'
          }, {
            value: 'no',
            label: 'Nee, ik ben medewerker/anders'
          }]} data-id="element-355" data-mp="dmoty7j2usb2" />
          </div>

          <div data-id="element-356" data-mp="2yf8ra6j8houj">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-357" data-mp="2ydpb0fxkvdsr">
              Bent u de uiteindelijke beslisser voor dit project?
            </label>
            <RadioGroup columns={2} value={data.isDecisionMaker} onChange={val => updateData({
            isDecisionMaker: val
          })} options={[{
            value: 'yes',
            label: 'Ja, ik neem de beslissingen'
          }, {
            value: 'no',
            label: 'Nee, ik overleg met anderen'
          }]} data-id="element-358" data-mp="18xld35wprlf6" />
          </div>

          <AnimatePresence data-id="element-359" data-mp="1nlpywir2cd26">
            {data.isDecisionMaker === 'no' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden" data-id="element-360" data-mp="21miqovpzcu1l">
                <div className="pt-6 border-t border-gray-100 space-y-6" data-id="element-361" data-mp="2dxjl6jyvi69e">
                  <div data-id="element-362" data-mp="2iw4l0ia7qnxb">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-363" data-mp="2iujqutrt96zz">
                      Overige beslissers / contactpersonen
                    </h3>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-364" data-mp="295s18sa82ys8">
                      Voeg de personen toe met wie u overlegt over dit project.
                    </p>
                  </div>

                  {data.owners.map((person, index) => <motion.div key={person.id} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="p-5 bg-gray-50 rounded-2xl border border-gray-200 relative" data-id="element-365" data-mp="205wlea5q2flv" data-mpi={index}>
                      <button onClick={() => removeDecisionMaker(person.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-366" data-mp="3kim6hzvukr3b">
                        <Trash2Icon className="w-4 h-4" data-id="element-367" data-mp="occs37w7aoey" />
                      </button>

                      <h4 className="font-semibold text-gray-900 mb-4 text-sm" data-id="element-368" data-mp="je1i8x5wodwq">
                        Contactpersoon {index + 1}
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-369" data-mp="1c1nko23edci0">
                        <Input label="Naam" placeholder="Volledige naam" value={person.name} onChange={e => updateDecisionMaker(person.id, 'name', e.target.value)} data-id="element-370" data-mp="1c3royl57kdit" />
                        <Input label="Functie / Rol" placeholder="Bijv. Directeur, Partner" value={person.role} onChange={e => updateDecisionMaker(person.id, 'role', e.target.value)} data-id="element-371" data-mp="22cz6svlfc7c1" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-372" data-mp="2q7aayns65xh0">
                        <Input label="E-mailadres" type="email" placeholder="naam@bedrijf.nl" value={person.email} onChange={e => updateDecisionMaker(person.id, 'email', e.target.value)} data-id="element-373" data-mp="2v0lfgi9ie25r" />
                        <Input label="Telefoonnummer" type="tel" placeholder="06 12345678" value={person.phone} onChange={e => updateDecisionMaker(person.id, 'phone', e.target.value)} data-id="element-374" data-mp="3pe2q83ic3ksy" />
                      </div>
                    </motion.div>)}

                  <Button variant="outline" onClick={addDecisionMaker} className="w-full border-dashed" data-id="element-375" data-mp="3ghjzmxxks8zj">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-376" data-mp="2nuh66k7raog5" />
                    Contactpersoon toevoegen
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}